import React, { useState } from "react";
import { Container } from "react-bootstrap";
import { motion, MotionConfig } from "framer-motion";
import ModalEmail from "../ModalEmail";
import RemoveModal from "../RemoveModal";
import ModalEmailone from "../ModalEmailone";
import RemoveEmailone from "../RemoveEmailone";
import SpecificModal from "../Specific_modal";
import { useShopManageState } from "../../../../hooks/useShopManageState";
import { useSaveShopMemberAccessMutation } from "../../../../features/shop/shopMemberApiSlice";
import {
  ShopManageHeader,
  ShopManageSummary,
  ShopTeamPanel,
} from "./components";
import "./style.css";

const ShopManage = () => {
  const [editingMember, setEditingMember] = useState(null);
  const [saveShopMemberAccess] = useSaveShopMemberAccessMutation();
  const {
    navigate,
    shopId,
    members,
    users,
    isTeamLoading,
    teamError,
    actionError,
    show,
    setShow,
    secondmodal,
    setSecondmodal,
    isShown,
    isShownsecond,
    openRemoval,
    closeRemoval,
    removeMember,
    removeUser,
  } = useShopManageState();

  return (
    <MotionConfig reducedMotion="user">
      <main className="shop-manage-page">
        <Container fluid className="shop-manage-container">
          <ModalEmail
            show={show}
            handleClose={() => setShow(false)}
            shopId={shopId}
          />
          <RemoveModal
            isShown={isShown}
            closeHandler={closeRemoval}
            handleRemoveClick={removeMember}
          />
          <ModalEmailone
            secondmodal={secondmodal}
            handleClosesecond={() => setSecondmodal(false)}
            shopId={shopId}
          />
          <RemoveEmailone
            isShownsecond={isShownsecond}
            closeHandlersecond={closeRemoval}
            handleRemoveUsers={removeUser}
          />
          {editingMember && (
            <SpecificModal
              showaccesstwo={Boolean(editingMember)}
              handleCloseaccesstwo={() => setEditingMember(null)}
              email={editingMember.email}
              initialAreas={editingMember.accessAreas || []}
              onClose={() => setEditingMember(null)}
              onGrantAccess={() => setEditingMember(null)}
              onSaveAccess={async (selectedAreas) => {
                const response = await saveShopMemberAccess({
                  shopId,
                  userId:
                    editingMember.userId ||
                    editingMember.user?._id ||
                    editingMember.id,
                  role: editingMember.rawRole || "member",
                  accessAreas: selectedAreas,
                }).unwrap();
                return {
                  membershipId: response?.data?.membershipId,
                  alreadyActive: Boolean(response?.data?.alreadyActive),
                  message: response?.message,
                };
              }}
              shopId={shopId}
            />
          )}

          <motion.div
            className="shop-manage-content"
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
          >
            <ShopManageHeader
              onBack={() => navigate(-1)}
              onInviteMember={() => setSecondmodal(true)}
              onAddAdmin={() => setShow(true)}
              shopId={shopId}
            />

            {!shopId && (
              <div className="shop-invite-invalid" role="alert">
                Open team management from a shop profile to choose the shop.
              </div>
            )}
            {(teamError || actionError) && (
              <div className="shop-invite-invalid" role="alert">
                {actionError ||
                  teamError?.data?.message ||
                  "Unable to load this shop’s team."}
              </div>
            )}

            <ShopManageSummary
              adminCount={members.length}
              memberCount={users.length}
            />

            <ShopTeamPanel
              isTeamLoading={isTeamLoading}
              members={members}
              users={users}
              onRemove={openRemoval}
              onEdit={setEditingMember}
            />
          </motion.div>
        </Container>
      </main>
    </MotionConfig>
  );
};

export default ShopManage;
